import { getQueryString, setCookie, getCookie } from './dom'
import { H5_LOCALE_REG_DOMESTIC } from '../constants/domesticLang'

// 是否是国内地区（写死的，2024年5月的CTA弹窗需求新增）
const countryCode = getQueryString('countryCode') || 'cn'
export const isDomestic = countryCode.toLowerCase() === 'cn'

export function getLocale(localeKey = 'locale', defaultLocale = 'zh_cn') {
  let locale = getQueryString(localeKey)
  
  if (!locale) {
    // query 没有 locale，读 cookie
    locale = getCookie(localeKey) || navigator.language
    return defaultLocale
  }

  // 默认值
  // let ret = 'zh_cn'
  
  // 有 locale，写入 cookie
  setCookie(localeKey, locale)
  locale = locale.replace(/[.-]/, '_').toLowerCase() // 统一把 . - 改成 _

  for (const i in H5_LOCALE_REG_DOMESTIC) {
    if (H5_LOCALE_REG_DOMESTIC[i].test(locale)) {
      defaultLocale = i
      break
    }
  }

  return defaultLocale
}
